import { MenuItem } from "@material-ui/core";

import { useTenant } from "src/components/LoggedInAdminProvider";
import { useSubaccount } from "src/components/SubaccountProvider";
import { FormikSelect } from "src/components/form/Select";
import { Role } from "src/graphql/generated/globalTypes";
import { equalAndLesserRoles, roleLabel } from "src/util/roles";

export default function useRoleSelector(): {
  defaultRoleSelection: Role | "";
  roleSelections: { label: string; value: Role }[];
} {
  const { membership } = useSubaccount()!;

  const roleSelections = equalAndLesserRoles(membership)
    .filter(role => role !== Role.TENANT_OWNER)
    .map(role => ({
      value: role,
      label: roleLabel(role)
    }));

  const defaultRoleSelection =
    roleSelections.length === 1 ? roleSelections[0].value : "";

  return {
    defaultRoleSelection,
    roleSelections
  };
}

export function FormikRoleSelector({
  roleSelections,
  name
}: {
  roleSelections: { label: string; value: Role }[];
  name: string;
}): JSX.Element {
  const tenant = useTenant()!;

  return (
    <>
      <FormikSelect
        withNoneOption
        noneOptionLabel="Select role..."
        fullWidth
        label="Role"
        name={name}
        disabled={roleSelections.length === 1}
      >
        {roleSelections.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </FormikSelect>
      <p>
        “Owner” is the highest permission level for this dialer{" "}
        {tenant.isUsingSubaccounts ? "subaccount" : "account"}. Owners can
        create and manage calling campaigns, manage account settings, add and
        edit integrations, add new Owners and Admins, and promote current Admins
        to be Owners.
      </p>
      <p>
        “Admins” can create and manage calling campaigns and add new Admins, but
        cannot manage account settings, add or edit integrations, nor add or
        promote Owners.
      </p>
    </>
  );
}
